import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";

export const optimizedIterationSchema = z.object({
  type: z.enum(["optimized-chunk-iteration", "optimized-iteration"]),
  data: z.object({
    iteration: z.number(),
    text: z.string(),
  }),
});

export class OptimizedIterationDto extends createZodDto(optimizedIterationSchema) {}
